import React from "react";

const Print = ({ id = "print-button" }) => {
  return (
    <div className="d-print-none p-2 col-sm-3 col-8 order-2 order-sm-1">
      <button
        id={id}
        className="btn-default btn btn-lg btn-secondary fs-px-16 w-100"
        onClick={() => window.print()}
      >
        Print this page
      </button>
    </div>
  );
};

export default Print;
